import React, { useEffect } from 'react';

/**
 * OAuth connect success page - shown in popup after successful OAuth callback.
 * Auto-closes the popup so the parent window can refresh status.
 */
const ConnectSuccessPage = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const success = params.get('success');
    const error = params.get('error');
    const isPopup = window.opener != null;

    if (isPopup) {
      // Notify parent of result (parent can show error toast if needed)
      if (window.opener && !window.opener.closed) {
        window.opener.postMessage(
          { type: 'oauth-callback', success: !!success, error: error || null },
          window.location.origin
        );
      }
      // Close after a brief delay so user sees the message
      const timer = setTimeout(() => {
        window.close();
      }, 1200);
      return () => clearTimeout(timer);
    } else {
      // Opened directly (e.g. bookmark) - redirect to integrations
      window.location.replace('/settings/integrations');
    }
  }, []);

  const params = new URLSearchParams(window.location.search);
  const hasError = params.get('error');
  const isNoSharePointLicense = hasError === 'no_sharepoint_license';

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white dark:bg-[#111111]">
      <div className="text-center px-6">
        {hasError ? (
          <>
            <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center">
              <svg className="w-6 h-6 text-red-600 dark:text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
            <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
              {isNoSharePointLicense ? 'SharePoint not available' : 'Connection failed'}
            </h2>
            <p className="text-sm text-gray-500 dark:text-gray-400 max-w-sm mx-auto">
              {isNoSharePointLicense
                ? 'SharePoint isn\'t available for this account. Personal accounts (Outlook.com, Hotmail) aren\'t supported. If you\'re using a work or school account, your organization may not have SharePoint Online enabled.'
                : 'This window will close. Please try again.'}
            </p>
          </>
        ) : (
          <>
            <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-green-100 dark:bg-green-900/30 flex items-center justify-center">
              <svg className="w-6 h-6 text-green-600 dark:text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
              Connected successfully!
            </h2>
            <p className="text-sm text-gray-500 dark:text-gray-400">
              This window will close automatically...
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default ConnectSuccessPage;
